// extracted by mini-css-extract-plugin
export default {"content":"DeleteJobZonePopup_content__cGThb"};